import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const PLANS = [
  { key: 'STARTER', labelKey: 'starter', popular: false },
  { key: 'GROWTH',  labelKey: 'growth',  popular: true  },
  { key: 'ENTERPRISE', labelKey: 'enterprise', popular: false },
];

function PricingPage() {
  const navigate = useNavigate();
  const { t } = useTranslation(['pricing', 'common']);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 via-amber-50 to-orange-100 px-4 py-10">
      <div className="w-full max-w-2xl">
        {/* Brand header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-extrabold tracking-tight">
            <span style={{ color: '#085041' }}>Bento</span>
            <span className="text-orange-600">Ping</span>
          </h1>
          <p className="text-sm text-gray-600 mt-1">{t('common:tagline')}</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-xl shadow-orange-100/60 border border-orange-100 p-8">
          <div className="flex items-start justify-between mb-2">
            <div>
              <h2 className="text-xl font-semibold text-gray-900 mb-1">{t('pricing:title')}</h2>
              <p className="text-sm text-gray-500">{t('pricing:subtitle')}</p>
            </div>
            <LanguageSwitcher className="text-sm border border-gray-200 rounded-lg px-2.5 py-1.5 text-gray-600 bg-gray-50 hover:border-orange-300 focus:outline-none focus:ring-2 focus:ring-orange-200 cursor-pointer" />
          </div>

          {/* Plan buttons */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            {PLANS.map(({ key, labelKey, popular }) => (
              <div key={key} className="relative flex flex-col items-center flex-1">
                {popular && (
                  <span className="mb-2 inline-flex items-center rounded-full bg-orange-100 px-3 py-0.5 text-xs font-semibold text-orange-700 border border-orange-200">
                    {t('pricing:mostPopular')}
                  </span>
                )}
                {!popular && <span className="mb-2 h-[22px]" aria-hidden="true" />}
                <button
                  type="button"
                  onClick={() => navigate(`/signup?plan=${key}`)}
                  className={
                    popular
                      ? 'w-full rounded-xl border-2 border-orange-500 bg-gradient-to-r from-orange-500 to-amber-600 px-6 py-4 text-base font-bold text-white shadow-md shadow-orange-200 transition hover:from-orange-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2 scale-105'
                      : 'w-full rounded-xl border-2 border-gray-200 bg-white px-6 py-4 text-base font-semibold text-gray-800 shadow-sm transition hover:border-orange-400 hover:text-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-200 focus:ring-offset-2'
                  }
                >
                  {t(`pricing:${labelKey}`)}
                </button>
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-6">
          {t('common:footer', { year: new Date().getFullYear() })}
        </p>
      </div>
    </div>
  );
}

export default PricingPage;